import {
  COMMON_TYPES,
  GetCategoriesListAction,
  GetCategoriesListSuccessAction,
  GetKeywordsListAction,
  GetKeywordsListSuccessAction,
  GetTagsListAction,
  GetTagsListSuccessAction,
} from './commonTypes';
import { CategoryListGetResponse } from '../../features/category/model/categoryModel';
import { TagGetResponse } from '../model/commonModel';
import { KeywordGetResponse } from '../../features/keyword/model/keywordModel';

export const getCategoriesList = (): GetCategoriesListAction => ({
  type: COMMON_TYPES.GET_CATEGORIES_LIST,
  payload: null,
});

export const getCategoriesListSuccess = (
  categoriesList: CategoryListGetResponse[],
): GetCategoriesListSuccessAction => ({
  type: COMMON_TYPES.GET_CATEGORIES_LIST_SUCCESS,
  payload: {
    categoriesList: categoriesList,
  },
});

export const getTagsList = (): GetTagsListAction => ({
  type: COMMON_TYPES.GET_TAGS_LIST,
  payload: null,
});

export const getTagsListSuccess = (tagsList: TagGetResponse[]): GetTagsListSuccessAction => ({
  type: COMMON_TYPES.GET_TAGS_LIST_SUCCESS,
  payload: {
    tagsList: tagsList,
  },
});

export const getKeywordsList = (): GetKeywordsListAction => ({
  type: COMMON_TYPES.GET_KEYWORDS_LIST,
  payload: null,
});

export const getKeywordsListSuccess = (keywordsList: KeywordGetResponse[]): GetKeywordsListSuccessAction => ({
  type: COMMON_TYPES.GET_KEYWORDS_LIST_SUCCESS,
  payload: {
    keywordsList: keywordsList,
  },
});
